// extracted by mini-css-extract-plugin
export default {"svg-button":"svg-button_svg-button__wwQPN"};